import { useMemo } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Fillup from "./Fillup";
import Mcq from "./MCQ";
import MMCQ from "./MMCQ";
import OneWord from "./OneWord";
import TrueFalse from "./TrueFalse";
import HotQuestion from "./HotQuestion";
import AssertionReasoning from "./AssertionQuestion";

const Question = ({ studentId, type, question, ind }) => {
  const params = useParams();
  const studId = useMemo(() => {
    return params.studentId || studentId;
  }, [params]);

  if (type === "mcq")
    return <Mcq studentId={studId} q={question} index={ind} />;
  else if (type === "oneword")
    return <OneWord studentId={studId} q={question} index={ind} />;
  else if (type === "correctstatement")
    return <TrueFalse studentId={studId} q={question} index={ind} />;
  // else if (type === "fillup") return <Fillup  studentId={studId}  q={question} index={ind} />;
  else if (type === "mmcq")
    return <MMCQ studentId={studId} q={question} index={ind} />;
  else if (type === "descriptive")
    return <HotQuestion studentId={studId} q={question} index={ind} />;
  else if (type === "assertion-reasoning")
    return <AssertionReasoning studentId={studId} q={question} index={ind} />;
  else return <></>;
};

export default Question;
